export default __webpack_public_path__ + "static/media/logo-veloprime-horizontal-color.c7e0b818.png";